<!-- 添加云盘抽屉页面 -->
<template>
    <div class="drawer-page" v-if="isShow">
        <div class="drawer-page-title">{{$t('language.addCloud.connectDesc')}}</div>
        <!-- 云盘列表 -->
        <div class="drawer-page-body">
            <div class="drawer-page-personal">
                <div class="add-txt">{{$t('language.addCloud.peCloud')}}</div>
                <el-scrollbar style='height:100%;' ref="pageScrollbar">
                    <div class="drawer-page-add-body">
                        <!-- 云盘实例 -->
                        <div class="drive-add-cloud" :key="index" v-for="(item,index) in addCloudLineUp" @click="addCloudDialog(item)">
                            <div class="add-cloud-item">
                                <div class='add-cloud-center'>
                                    <div class="cloud cloud-size cloudPosition" :class="item.appName"></div>
                                    <div class="add-cloud-item-name">{{$t('language.addCloud.'+item.appName)}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-scrollbar>
            </div>
            <div class="drawer-page-business">
                <div class="add-txt">{{$t('language.addCloud.buCloud')}}</div>
                <el-scrollbar style='height:100%;' ref="pageScrollbar">
                    <div class="drawer-page-add-body">
                        <!-- 云盘实例 -->
                        <div class="drive-add-cloud" :key="index" v-for="(item,index) in addCloudLineDown" @click="addCloudDialog(item)">
                            <div class="add-cloud-item">
                                <div class='add-cloud-center'>
                                    <div class="cloud cloud-size cloudPosition" :class="item.appName"></div>
                                    <div class="add-cloud-item-name">{{$t('language.addCloud.'+item.appName)}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-scrollbar>
            </div>
        </div>
        <addCloudDialog ref="addCloudDialog"></addCloudDialog>
        <addFtpDialog ref="addFtpDialog"></addFtpDialog>
        <addNasDialog ref="addNasDialog"></addNasDialog>
        <addSpecialDialog ref="addSpecialDialog"></addSpecialDialog>
    </div>
</template>

<script>
import commonstate from '@/js/constant.js';
import commonUtils from "@/js/workspace/common_util.js";
import addCloudUtils from '@/js/workspace/add_cloud_utils.js';
import addCloudDialog from '@/components/popup/add_cloud_popups/add_cloud_popup';
import addFtpDialog from '@/components/popup/add_cloud_popups/add_ftp_popup';
import addNasDialog from '@/components/popup/add_cloud_popups/add_nas_popup';
import addSpecialDialog from '@/components/popup/add_cloud_popups/add_special_cloud_popup';
function sortDown (x, y) {
    return y.level - x.level;
}
export default {
    name: "darwerAddEmailPage",
    components: {
        addCloudDialog,
        addFtpDialog,
        addNasDialog,
        addSpecialDialog,
    },
    data() {
        return {
            isShow: false,
            addCloudLineUp: [],
            addCloudLineDown: [],
            unavailCloud: ['facebook', 'goDaddy', 'copy', 'team', 'picasa', 'ubuntu', 'youtube', 'bitcasa','apple'],
            directlyAddCloud:['google_drive','google_drive_sharedWithMe','gSuiteSharedDrive','dropbox','oneDrive','box','boxBusiness','pCloud','dropbox4Business','oneDrive4Business','sharePointOnline'],
        }
    },
    mounted() {
        window.addEventListener('message', this.addCloudCallBack);
        var getter = this.$store.getters;
        if (getter && this.$store.state.addCloudLineUp && this.$store.state.addCloudLineDown) {
            this.addCloudLineUp = this.$store.state.addCloudLineUp;
            this.addCloudLineDown = this.$store.state.addCloudLineDown;
        } else {
            this.getCloudsLine();
        }
    },
    methods: {
        init() {
            //触发初始化和动画
            this.isShow = true;
            if(!this.addCloudLine){
                this.getCloudsLine();
            }
        },
        getCloudsLine () {
            //获取云盘种类并存储在store中
            let CategoriesAll = commonstate.cloudCategories;
            let jsonTargetUp = [];
            let jsonTargetDown = [];
            for(var i=0;i<CategoriesAll.length;i++){
                var item = CategoriesAll[i];
                    if (!item.bussiness) {
                        if (!this.unavailCloud.includes(item.appName) && !commonstate.emailClouds.includes(item.appName) && item.appName != 'amazon') {
                            jsonTargetUp.push(item);
                        }
                } else  {
                    jsonTargetDown.push(item);
                }
            }
            this.addCloudLineUp = jsonTargetUp.sort(sortDown);
            this.addCloudLineDown = jsonTargetDown.sort(sortDown);
            this.$store.commit('setAddCloudLineUp', this.jsonTargetUp);
            this.$store.commit('setAddCloudLineDown', this.jsonTargetDown);
        },
        //打开添加云盘弹窗
        addCloudDialog (item) {
            //2024-06-26 临时
            if(item.appName == 'google_drive' || item.appName == 'google_drive_sharedWithMe') {
                let user = commonUtils.getUser();
                if(user.id != "0f57a15c154244cb8e17e9adda9dd4d0") {
                    this.$toast({
                        text: "Our Google drive project is in status of \"reverification in progress\", it may take a few days.",
                        type: 'notice',
                        idValue: "rightContBan"
                    });
                    return;
                }
            }
            if(item.appName == 'gSuite'  || item.appName == 'gSuiteSharedDrive' || item.appName == 'boxBusiness' 
            || item.appName =='dropbox4Business' || item.appName =='oneDrive4Business'){
                this.$refs.addSpecialDialog.specialCloudShow =true;
                this.$refs.addSpecialDialog.cloudInfo = item;
                return;
            }
            if (item.appName == "FTP") {//如果是ftp云盘
                this.$refs.addFtpDialog.ftpDialog = true;
                this.$refs.addCloudDialog.cloudDialog = false;
                this.$refs.addFtpDialog.cloudName = item.appName;
                this.$refs.addFtpDialog.cloudIcon = item.appName;
                this.$refs.addFtpDialog.cloudInfo = item;
            }else if(this.directlyAddCloud.includes(item.appName)){
                let that=this;
                let redirectUrl = commonstate.addFromEmailTransRedirectUrl;
                let user=commonUtils.getUser();
                let name=this.$t('language.addCloud.'+item.appName).trim().replace(/\s+/ig, " ");
                let allDrives = Object.assign([], this.$store.getters.getUsersDrives);
                let nameArr=[];
                $.each(allDrives, function (i, item) {
                    nameArr.push(item.name);
                });
                commonUtils.includesDriveName(nameArr, name, that);
                let addData = new addCloudUtils.addCloudData(user.id, that.reName, null, null, null, null, null, null, item.appName, null, null, redirectUrl);
                //请求后端数据
                this.Utils.doDrivesRequest("add", addData).then(res => {
                    if (res.status == 201) {//打开第三方网页
                        var allDrives = Object.assign([], this.$store.getters.getUsersDrives);
                        localStorage.setItem(user.id+'driveNum',allDrives.length);//用户的云盘列表长度
                        that.Utils.openNewWin(res);
                    }else{
                        if(res.status == 401){
                            this.$toast({
                                text: this.$t('language.exception.' + res.reason),
                                type: 'fail',
                                idValue: "emailTransfer"
                            });
                        }
                    }
                });
            } else if (item.appName == "NAS") {//如果是nas
                this.$refs.addNasDialog.nasShow = true;
                this.$refs.addCloudDialog.cloudDialog = false;
                this.$refs.addNasDialog.activeName = 'first';
                let tab1 = this.$refs.addNasDialog.$refs.viaFtp;
                let tab2 = this.$refs.addNasDialog.$refs.viaWebDav;
                this.$refs.addNasDialog.$refs.nasDiv.style.height = 470 + 'Px';
                tab1.advancedShow = false;
                tab1.optional = null;
                tab1.email = null;
                tab1.password = null;
                tab1.path = null;
                tab2.username = null;
                tab2.password = null;
                tab2.path = null;
            } else {//如果是除ftp和nas以外的普通云盘
                this.resetAddCloudData();
                this.$refs.addCloudDialog.cloudDialog = true;
                this.$refs.addCloudDialog.cloudInfo = item;
                this.$nextTick(function () {
                    addCloudUtils.getContainerHeight(this.$refs.addCloudDialog);
                });
                this.$refs.addCloudDialog.cloudName = item.appName;
                this.$refs.addCloudDialog.tipShow = false;
                this.$refs.addCloudDialog.inputCloudNameValue = this.$t('language.addCloud.' + item.appName);
                this.$refs.addCloudDialog.cloudIcon = item.appName;
            }
        },
        //打开界面重置添加云盘数据
        resetAddCloudData () {
            this.$refs.addCloudDialog.email = '';
            this.$refs.addCloudDialog.password = '';
            this.$refs.addCloudDialog.username = '';
            this.$refs.addCloudDialog.keyID = '';
            this.$refs.addCloudDialog.applicationKey = '';
            this.$refs.addCloudDialog.bucketName = '';
            this.$refs.addCloudDialog.otherServerHttp = '';
        },
    },
}
</script>
<style scoped>
.add-cloud-item-name-coming {
    background: #E4E7F3;
    border-radius: 9px;/*no*/
    width: fit-content !important;
    padding: 0 10px;/*no*/
}

.drawer-page {
    padding-left: 40px;/*no*/
    width: 55vw;
    height: 100%;
}

.drawer-page-title {
    line-height: 80px;/*no*/
    font-size: 26px;/*no*/
    font-family: Arial;
    font-weight: bold;
    color: #262833;
}

.drawer-page-body {
    width: calc(100% - 80px);/*no*/
    height: calc(100% - 150px);/*no*/
}

.drawer-page-personal {
    height: calc(100% - 306px);/*no*/
    min-height: 176px;/*no*/
    border-radius: 8px;/*no*/
    padding: 54px 0 20px;/*no*/
    position: relative;
    background: #F5F6FA;
}

.drawer-page-business {
    margin-top: 30px;/*no*/
    height: 176px;/*no*/
    border-radius: 8px;/*no*/
    padding: 54px 0 20px;/*no*/
    position: relative;
    background: #F5F6FA;
}

.drawer-page-add-body {
    padding: 0 20px;/*no*/
}

/*云盘添加列表界面*/
.drive-add-cloud {
    width: 20%;
    float: left;
    color: rgba(0, 0, 0, 0.6);
    height: 130Px;
}

.drive-add-cloud:hover {
    box-shadow: 0px 2px 8px rgba(62,70,120,0.46);/*no*/
    background: #FFFFFF;
    border-radius: 3px;/*no*/
}

.add-cloud-item {
    display: flex;
    align-items: center;
    justify-content: center;
}

.add-cloud-item-name {
    width: 100%;
    height: 20%;
    font-size: 14px;
    /*no*/
    text-align: center;
    margin: auto;
    margin-top: 5Px;
    float: none !important;
}

.cloudPosition {
    position: relative;
    top: 5px;
    /*no*/
}

.add-txt{
    position: absolute;
    font-weight:bold;
    top: 15Px;
    left: 15Px;
}
</style>


// WEBPACK FOOTER //
// src/components/drawer/page/add_cloud.vue